import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ProjectConfigsService } from 'src/app/akita/project-configs/state/project-configs.service';
import { AvatarNotificationCustomStyle } from 'src/app/core/enum/styles';
import { GeneralService } from 'src/app/core/service/api/general.service';
import { InAppChatService } from 'src/app/core/service/api/in-app-chat.service';
import { PubsubService } from 'src/app/core/service/api/pubsub.service';
import { IntegrationsService } from 'src/app/core/service/integrations.service';
import { openModal } from 'src/app/core/util/dashboardModalLogic';
import { Notifications, showFeedbackSaved } from 'src/app/core/util/notification';
import { Globals } from 'src/app/globals';
import { setDefaultLanguage } from 'src/app/akita/multilingual/multilingual.model';
import { Router } from '@angular/router';
@Component({
  selector: 'app-in-app-notification',
  templateUrl: './in-app-notification.component.html',
  styleUrls: ['./in-app-notification.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InAppNotificationComponent implements OnInit {
  public AvatarNotificationCustomStyle = AvatarNotificationCustomStyle;
  @Input() notification:Observable<Notifications>;
  @Output() bouwappNotificationConfirmation: EventEmitter<any> = new EventEmitter();
  @Output() loadNotification: EventEmitter<any> = new EventEmitter();
  public integrationLevel;
  public language: any;
  errorMessage_userleve:boolean=false;
  // eslint-disable-next-line no-empty-function
  constructor(
    private cd: ChangeDetectorRef,
    private _integrationsService: IntegrationsService ,
    public _inAppChatService: InAppChatService,
    private _generalService: GeneralService,
    private globals: Globals,
    private projectConfigs:ProjectConfigsService,
    public dialog: MatDialog,
    private pubsub: PubsubService,
    private router: Router
  ) { }
  ngOnInit(): void {
    this.language = setDefaultLanguage(this.globals,'user')
  }


  public updateBouwappMiddle(data,action){
    this._generalService.updateNotification(data,action).subscribe(res=>{
      this.loadNotification.emit();
      showFeedbackSaved();
    });
  }
  public bouwappNotificationConform(message){
    this.bouwappNotificationConfirmation.emit(message);
  }
  public middleRoute(route){
    if (route.id) {
      return `/${this.globals.projectCode}/communicatiekalender/middel/${route.id}`;
    }
    return `/${this.globals.projectCode}/communicatiekalender/middel`;
      
  }
  public nav(item_id,type,data,chat=false): void{
    if (type !== 'item_deleted' && type !== 'shared_projects' && type !== 'shared_items') {
      openModal(type,data,this.dialog,this.pubsub,chat).afterClosed().subscribe();
      this._generalService.clearNotifications(this.notification[item_id].id).subscribe();
    } else if (type === 'shared_projects') {
      const item_type = this.notification[item_id].data.type;
      const new_type = item_type==='comment_posted' ? `${type}_${item_type}`:item_type;
      openModal(new_type,this.notification[item_id],this.dialog,this.pubsub,chat).afterClosed().subscribe(()=>{
        if(item_type!=='comment_posted') this._generalService.updateConnectionsNotification('refresh');
        this.loadNotification.emit(true);
      });
      this._generalService.clearChatNotifications(this.notification[item_id].id).subscribe();
    } else if (type === 'shared_items') {
      const metadata = this.notification[item_id].data.data.metadata;
      const project = this.globals.projectCode === metadata.source_project_code ? metadata.source_project_code: metadata.target_project_code;
      const subproject = this.globals.projectCode === metadata.target_project_code ? metadata.source_project_code: metadata.target_project_code;
      let item_type = metadata.item_type.toLowerCase();
      item_type = item_type==="contactpersons" ? "stakeholders/contactpersonen": item_type==="requirements" ? 'klanteisen': item_type=="tasks" ? 'acties': item_type=="complaints" ? 'meldingen': item_type=="contactmoments" ? 'contactmomenten': item_type=="activities" || item_type=="contents" ? 'communicatiekalender': item_type=="documents" ? 'documenten': item_type;
      const subRoute: boolean = this.notification[item_id]?.data?.data.type === 'item_shared_requested' ? true: false;
      const route: string = subRoute ? `/${project}/sub/${subproject}/${item_type}` : `/${project}/${item_type}`;
      const navItemId = metadata.source_item?.id? metadata.source_item.id : metadata.target_item?.id;
      this.pubsub.emitOpenSharedItemFromNotification({
        item_type,
        item_id: navItemId,
        group: 'shared_items',
        item_shared_requested: this.notification[item_id]?.data?.data.type === 'item_shared_requested' ? true: false,
        extraData: this.notification[item_id],
      });
      this.router.navigateByUrl(
        route,
        {
          state: {
            fromNotification: true,
            notificationId: this.notification[item_id].id,
            item_id: navItemId,
            item_shared_requested: this.notification[item_id]?.data?.data.type === 'item_shared_requested' ? true: false,
            extraData: this.notification[item_id],
          }
        }
      );
      this._generalService.clearChatNotifications(this.notification[item_id].id).subscribe();
    }

    if(type!=='shared_projects'&&type!=='shared_items') this.loadNotification.emit();
  }

  public isSharedProjectNotification(notifyType: string): boolean {
    const sharedProjectNotificationTypes = ['project_shared_requested', 'project_shared_upgrade_requested', 'project_shared_cancelled', 'project_shared_upgrade_cancelled', 'project_shared_accepted', 'project_shared_upgrade_accepted'];
    return sharedProjectNotificationTypes.includes(notifyType);
  }
}
